<template>
    <div>
        <!--        성인인증-->
        <li class="i_w_content">
            <h3 class="sub_title no_caution_img ">{{ $t('adult_in') }}</h3>
            <div class="w_content_box">
                <el-radio-group class="el_radio_box" v-model="isCheckAdult"
                                @change="parentChange('isCheckAdult', isCheckAdult)">
                    <el-radio class="el_radio_btn" :label="1">{{ $t('yes2') }}</el-radio>
                    <el-radio class="el_radio_btn" :label="0">{{ $t('no2') }}</el-radio>
                </el-radio-group>
            </div>
        </li>
        <!--        상세이미지-->
        <li class="i_w_content detail_thumb_wrap ">
            <h3 class="sub_title no_caution_img">{{ $t('d_thumb') }}</h3>
            <div class="w_content_box">
                <div class="c_el_up" v-for="(data, index) in detailFile"
                     :key="`detailFile${index}`">
                    <div class="el-upload el-upload--picture-card">
                        <img v-if="hasFile('detailFile')"
                             :src="data.org_url" class="">
                        <button v-if="hasFile('detailFile')" class="upload_del_btn"
                                @click="removeList('detailFile',index)"></button>
                    </div>
                </div>
                <el-upload
                        class="n_el_up"
                        action=""
                        list-type="picture-card"
                        :show-file-list="false"
                        :file-list="detailFile"
                        :auto-upload="false"
                        :on-change="detailFileChange"
                >
                    <img src="@/assets/image/main/change_item.png" alt="" style="width: 93px; height: 74px;">
                </el-upload>
            </div>
        </li>

    </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import elFileMixins from "@/mixins/elFileMixins";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    name: "ItemExtraInfoLayout",
    mixins: [elFileMixins, alertMixins],
    components: {},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setDeleteFiles: {
            default: () => {
            }, type: Function
        },
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,}
    },
    data() {
        return {
            detailFile: [],
            isCheckAdult: 0,
            validatorArr: [],

            detailMaxSize: 20 * 1024 * 1024,
        }
    },
    created() {
        if (this.isItemData()) {
            this.settingItemData();
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        settingItemData() {
            this.detailFile = this.$_.cloneDeep(this.itemData.detailFile);
            this.isCheckAdult = this.itemData.isCheckAdult;
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        hasFile(type) {
            return !util.isEmpty(this[type]);
        },
        checkValidator() {

        },
        _checkFileSize(size, max) {
            if (size > max) {
                let sizeMB = max / 1024 / 1024
                this.errorAlert(this.$t('uploadFile_error1', {size: sizeMB + "MB"}));
                return false;
            }
            return true;
        },
        detailFileChange(file, fileList) {
            console.log(fileList)
            file = this.makeFileObj(file);
            let type = file.raw.type.split('/');
            if (this.detailFile.length > 9) {
                fileList.pop();
                this.errorAlert(this.$t('l_img1'))
                return false;
            }
            if (!this._checkFileSize(file.size, this.detailMaxSize)) {
                fileList.pop();
                return false;
            }
            if (!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert(this.$t('uploadFile_error2'))
                fileList.pop();
                return false;
            }
            this.detailFile = fileList;
            this.parentChange('detailFile', this.detailFile);
            this.$forceUpdate();
        },
        removeList(type, index) {
            let files = this[type].splice(index, 1);
            this.setDeleteFiles(files)
            this.parentChange(`${type}`, this[type])
            this.$forceUpdate();
        },
    },
    watch: {},
    validators: {
        detailFile: function (value) {
            return Validator.value(value)
        },
        isCheckAdult: function (value) {
            return Validator.value(value)
        },

    },
}
</script>

<style scoped>

</style>
